import React, { useEffect, useState } from 'react';
import {
  Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupText, Label, Row,
} from 'reactstrap';
import { useTranslation, withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
/** User defined */
import LanguagePicker from '../../Component/Picker/LanguagePicker';
import ErrorMessage from '../../Component/ErrorMessage';
import Loading from '../../Component/Loading';
import { useLogin } from '../../../hooks/useLogin';
import logHandling from '../../../helper/logHandling';
/* CSS */
import 'animate.css';

const Login = () => {
  const [ capsOn, setCapsOn ] = useState(false);
  const [ userError, setUserError ] = useState(false);
  const [ passError, setPassError ] = useState(false);
  const [ errorMsg, setErrorMsg ] = useState('');

  const history = useHistory();
  const { loginState, setLoginState, triggerLogin } = useLogin();
  const { t, i18n } = useTranslation();
  const { auth, mfa, error, loading } = useSelector((store) => store.auth);

  useEffect(() => {
    (() => {
      try {
        // changeLanguage(loginState.language);  // Old Trigger re render !!!! Warning
        const username = localStorage.getItem('userad');
        if (username) {
          const user = {
            user: username,
            password: '',
          };
          setLoginState({
            ...loginState,
            user,
            remember: true,
          });
        }
      } catch (err) {
        // error handle
        console.log('COMPONENT ERROR: ', err);
        logHandling(err);
      }
    })();
  }, []);

  useEffect(() => { 
    //console.log(error);
    if (error?.status === 401) {
      //console.log('no verificar datos');
      setErrorMsg(t('Login.failMessage'));
    }
    if (error?.status === 423) {
      if (error.code === 'ALREADY_LOGGED_IN'){
        setErrorMsg(t('Login.concurrent'));
      }
      if (error.code === 'IP_BLOCKED'){
        //console.log('Bloqueado');
        setErrorMsg(t('Login.blockedUser'));
      }
    }
    if (errorMsg === ''  && error.status !== 401 && error.status !== 423) {
      setErrorMsg(error.message);
    }
  }, [error]);

  // Escucho si es necesario MFA
  useEffect(() => {
    if (mfa?.required) {
      history.push('/mfa');
    }
  }, [mfa?.required]);

  useEffect(() => {
    if (auth && !!auth.authenticated) {
      if (auth && !!auth.canLogin) {
        // Esta Logueado y es super admin --> impersonate
        history.push('/impersonate');
      } else {
        // alert('Esta logueado, ver si no es super admin');
        history.push('/');
      }
    }
  }, [auth.authenticated]);

  const changeLanguage = (lng) => {
    console.log('change lng: ', lng);
    i18n.changeLanguage(lng);
  };

  const login = async () => {
    triggerLogin();
  };

  const handleLanguageChange = (event) => {
    const language = event.target.value;
    console.log(language);
    setLoginState({
      ...loginState,
      language,
    });
    changeLanguage(language);
  };

  const onKeyPress = (target) => {
    if (target.charCode === 13) {
      login();
    }
  };

  const handleUserInput = (event) => {
    const regex = /^[a-zA-Z0-9]+$/;
    const { user, emptyField } = loginState;
    const { target } = event;
    const { value, name } = target;
    emptyField[name].childStyle = {};
    emptyField[name].class = '';
    user[name] = value;
    setLoginState({
      ...loginState,
      emptyField,
      user,
    });
    if(regex.test(loginState.user.user) || loginState.user.user.length == 0){
      setUserError(false);
    } else {
      if(loginState.user.user.length > 0){
        setUserError(true);
      }
    }
    if(!/\s/.test(loginState.user.password) || loginState.user.password.length == 0){
      setPassError(false);
    } else {
      if(loginState.user.password.length > 0){
        setPassError(true);
      }
    }
  };

  const showPassword = () => {
    if (loginState.inputType === 'password') {
      setLoginState({
        ...loginState,
        showPassIcon: 'fa fa-eye', // 'icon-ban',
        inputType: 'text',
      });
    } else {
      setLoginState({
        ...loginState,
        inputType: 'password',
        showPassIcon: 'fa fa-eye-slash', // 'icon-eye',
      });
    }
  };

  const handleRemember = () => {
    setLoginState({
      ...loginState,
      remember: !loginState.remember,
    });
  };

  const handleKeyPress = (event) => {
    const capsLockOn = event.getModifierState('CapsLock');
    // Display a warning message if Caps Lock is on
    if (capsLockOn) {
      setCapsOn(capsLockOn)
    } else {
      setCapsOn(capsLockOn)
    }
  };

  return (
    <div>
      { loading ? (<Loading loading />) : (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1 style={{ marginBottom: 30, textAlign: 'center' }}>PIMS Admin</h1>

                      <InputGroup className={`mb-3 ${loginState.emptyField.user.class}`}>
                        <div className="input-group-prepend">
                          {/* <InputGroupAddon addonType="prepend"> */}
                          <InputGroupText>
                            <i className="icon-user"> </i>
                          </InputGroupText>
                        </div>
                        {/* </InputGroupAddon> */}
                        <Input
                          type="text"
                          placeholder={t('Login.user')}
                          name="user"
                          value={loginState.user.user}
                          onChange={(e) => handleUserInput(e)}
                          onKeyDown={onKeyPress}
                          onKeyUp={(e) => handleKeyPress(e)}
                          style={loginState.emptyField.user.childStyle}
                          maxLength="30"
                          role='textbox'
                        />
                      </InputGroup>
                      {(userError) && (
                          <ErrorMessage style={{ marginLeft: 15 }} message={t('Login.userError')} />
                      )}

                      <InputGroup className={`mb-4 ${loginState.emptyField.password.class}`}>
                        <div className="input-group-prepend">
                          {/* <InputGroupAddon addonType="prepend"> */}
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                          {/* </InputGroupAddon> */}
                        </div>
                        <Input
                          type={loginState.inputType}
                          placeholder={t('Login.password')}
                          name="password"
                          value={loginState.user.password}
                          onKeyDown={onKeyPress}
                          onKeyUp={(e) => handleKeyPress(e)}
                          onChange={(e) => handleUserInput(e)}
                          style={loginState.emptyField.password.childStyle}
                          maxLength="30"
                          minLength="4"
                          role='textbox'
                        />
                        <div
                          className="input-group-prepend"
                          onClick={showPassword}
                          onKeyDown={showPassword}
                          role="button"
                          tabIndex="0"
                        >

                          {/* <InputGroupAddon addonType="prepend" onClick={showPassword}> */}
                          <InputGroupText>
                            <i className={loginState.showPassIcon} />
                          </InputGroupText>
                          {/* </InputGroupAddon> */}
                        </div>
                      </InputGroup>
                      {(passError) && (
                          <ErrorMessage style={{ marginLeft: 15 }} message={t('Login.passError')} />
                      )}

                      <InputGroup className="mb-4" style={{ marginTop: -10 }}>
                        <div className="input-group-prepend w-100">
                          {/* <InputGroupAddon addonType="prepend"> */}
                          <InputGroupText>
                            <i className="fa fa-language" />
                          </InputGroupText>
                          <div style={{ float: 'left' }} className="w-100">
                            <LanguagePicker
                              className="custom-select"
                              id={loginState.language}
                              onChange={handleLanguageChange}
                              bsSize="sm"
                              role="lang-picker"
                            />
                          </div>
                        </div>
                        {/* </InputGroupAddon> */}
                      </InputGroup>
                      
                      <InputGroup style={{ margin: '-10px 0px 10px 20px' }}>
                        <Label check style={{ marginRight: 0 }}>
                          <Input
                            type="checkbox"
                            checked={loginState.remember}
                            onChange={handleRemember}
                            role='check-input'
                          />
                          <span>&nbsp;</span>
                          {t('Login.remember')}
                        </Label>
                      </InputGroup>
                      {
                        capsOn && 
                        (
                          <div>
                            <ErrorMessage style={{ marginLeft: 15 }} message={t('Login.capsAlert')}/>
                            <br />
                          </div>
                        )
                      }
                      {
                        (errorMsg) ? 
                        (
                          <ErrorMessage style={{ marginLeft: 15 }} message={errorMsg} danger/>
                        )
                        : (<div></div>)
                      }
                      <Row>
                        <Button color="success" className="px-4 w-100" onClick={() => login()} style={{ marginLeft: 15 }}>{t('Login.login')}</Button>
                      </Row>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      )
        }
    </div>
  );
};

export default (withTranslation()(Login));
